import { defineComponent as _defineComponent } from 'vue';
import { createVNode as _createVNode, createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, unref as _unref, withCtx as _withCtx, createStaticVNode as _createStaticVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue";
const _hoisted_1 = { class: "footerFixed" };
const _hoisted_2 = {
    id: "all_wrapper",
    class: "policy"
};
const _hoisted_3 = { class: "wrapper_1" };
import { Link } from '@inertiajs/inertia-vue3';
import headerVue from '@layout/header.vue';
import footerVue from '@layout/footer.vue';
export default /*@__PURE__*/ _defineComponent({
    __name: 'policy',
    props: {
        common: {}
    },
    setup(__props) {
        const props = __props;
        return (_ctx, _cache) => {
            return (_openBlock(), _createElementBlock("div", null, [
                _createVNode(headerVue, {
                    common: props.common
                }, null, 8, ["common"]),
                _createElementVNode("div", _hoisted_1, [
                    _createElementVNode("div", _hoisted_2, [
                        _createElementVNode("div", _hoisted_3, [
                            _cache[3] || (_cache[3] = _createElementVNode("h2", null, "ShareMentors プライバシーポリシー", -1)),
                            _cache[4] || (_cache[4] = _createElementVNode("div", { class: "date" }, "2023年3月31日 制定", -1)),
                            _createElementVNode("dl", null, [
                                _cache[2] || (_cache[2] = _createStaticVNode("<dt>１．基本方針</dt><dd>「ＳｈａｒｅＭｅｎｔｏｒｓ株式会社」（以下、「当社」といいます。）は、当社が取得した個人情報の取扱いに関し、個人情報の保護に関する法律、個人情報保護に関するガイドライン等の指針、その他個人情報保護に関する関係法令を遵守します。</dd><dt>２．個人情報の安全管理</dt><dd>当社は、個人情報の保護に関して、組織的、物理的、人的、技術的に適切な対策を実施し、当社の取り扱う個人情報の漏えい、滅失又はき損の防止その他の個人情報の安全管理のために必要かつ適切な措置を講ずるものとします。</dd><dt>３．個人情報の取得等の遵守事項</dt><dd>当社による個人情報の取得、利用、提供については、以下の事項を遵守します。 <dl><dt>(1) 個人情報の取得</dt><dd>当社は、当社が管理する本ウェブサイト上で提供するサービス（以下、「本サービス」といいます。）の運営に必要な範囲で、本サービスの利用者（以下「ユーザー」といいます。）から、ユーザーに係る個人情報を取得することがあります。</dd><dt>(2) 個人情報の利用目的</dt><dd>当社は、当社が取得した個人情報について、法令に定める場合又は本人の同意を得た場合を除き、以下に定める利用目的の達成に必要な範囲を超えて利用することはありません。<br><br> ①本サービスの運営、維持、管理<br> ②本サービスを通じたサービスの提供及び紹介<br> ③本サービスの品質向上のためのアンケート</dd><dt>(3) 個人情報の提供等</dt><dd>当社は、法令で定める場合を除き、本人の同意に基づき取得した個人情報を、本人の事前の同意なく第三者に提供することはありません。なお、本人の求めによる個人情報の開示、訂正、追加若しくは削除又は利用目的の通知については、法令に従いこれを行うとともに、ご意見、ご相談に関して適切に対応します。</dd><dt>(4) Webサイトにおける個人情報等の取扱いについて</dt><dd>当社では、第三者から配信される広告を利用する場合があり、 これに関連して、当該第三者が、当社サイトを訪問したユーザーのクッキー情報・広告識別子、 当社サイトへの訪問やアプリの利用・行動情報などを取得、利用している場合があります。 当該第三者によって取得されたクッキー情報・広告識別子等は、当該第三者のプライバシーポリシーに従って取り扱われます。 ユーザーは、以下の方法にて、当該第三者によるクッキー情報・広告識別子等の広告配信への利用を停止できます。<br><br> 【ブラウザーの場合】<br> 当該第三者のウェブサイトに設けられた無効化(オプトアウト)ページにアクセス<br><br> 【アプリの場合】<br> 利用端末の広告識別子設定画面にアクセス<br> ※詳しい設定方法は、各端末のOSを提供しているApple社、Google社などの案内を確認してください。</dd></dl></dd><dt>４．個人情報の利用目的の変更</dt><dd> 当社は、前項で特定した利用目的は、予め本人の同意を得た場合を除くほかは、原則として変更しません。但し、変更前の利用目的と相当の関連性を有すると合理的に認められる範囲において、予め変更後の利用目的を公表の上で変更を行う場合はこの限りではありません。 </dd><dt>５．個人情報の第三者提供</dt><dd> 当社は、個人情報の取扱いの全部又は一部を第三者に委託する場合、その適格性を十分に審査し、その取扱いを委託された個人情報の安全管理が図られるよう、委託を受けた者に対する必要かつ適切な監督を行うこととします。 </dd><dt>６．個人情報の取扱いの改善・見直し</dt><dd> 当社は、個人情報の取扱い、管理体制及び取組みに関する点検を実施し、継続的に改善・見直しを行います。 </dd><dt>７．お問い合せ窓口</dt>", 13)),
                                _createElementVNode("dd", null, [
                                    _createVNode(_unref(Link), { href: "/inquiry" }, {
                                        default: _withCtx(() => _cache[0] || (_cache[0] = [
                                            _createTextVNode("お問合せフォーム")
                                        ])),
                                        _: 1,
                                        __: [0]
                                    }),
                                    _cache[1] || (_cache[1] = _createTextVNode("よりご連絡ください。 "))
                                ])
                            ])
                        ])
                    ]),
                    _createVNode(footerVue)
                ])
            ]));
        };
    }
});
